import { useLayoutEffect, type RefObject } from 'react';

/** Чи вміє браузер сам підганяти висоту поля під вміст (CSS field-sizing: content). */
const nativeSizing = (): boolean => typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('field-sizing', 'content');

/**
 * Висота багаторядкового поля за вмістом (UIUX/controls/textarea «grows with content»): браузери з field-sizing роблять це самі,
 * для решти — висота за scrollHeight після кожної зміни значення (мін. висоту задає CSS).
 */
export function useAutosize(ref: RefObject<HTMLTextAreaElement>, value: string): void {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || nativeSizing()) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight + 2}px`;
  }, [ref, value]);
}
